import { useState } from 'react'
import getThresholdValueFlu from '../../utils/getThresholdValueFlu'
import getThresholdValue from '../../utils/getThresholdValue'
import colorAxis from './colorAxisLevel'
export default function MapLegend(props) {
    return (
      <>
           <svg viewBox="0 0 450 25" height="25" width="460" align="center" {...props}>
    
    <rect
      x="0"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[5].color}
      stroke={colorAxis.dataClasses[5].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="25"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      {colorAxis.dataClasses[5].name}
    </text>
    <rect
      x="80"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[4].color}
      stroke={colorAxis.dataClasses[4].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="105"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[4].name}
    </text>
    <rect
      x="155"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[3].color}
      stroke={colorAxis.dataClasses[3].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="180"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[3].name}
    </text>
    <rect
      x="230"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[2].color}
      stroke={colorAxis.dataClasses[2].borderColor}
      strokeWidth="1px"
    ></rect>
     <text
      x="255"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[2].name}
    </text>
    <rect
      x="305"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[1].color}
      stroke={colorAxis.dataClasses[1].borderColor}
      strokeWidth="1px"
    ></rect>

    <text
      x="330"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[1].name}
    </text>
    <line x1="370" y1="0" x2="370" y2="18" stroke="#CBCCCD" strokeWidth={2} />
    <rect
      x="380"
      y="0"
      width="16"
      height="16"
      fill="#6D6F70"
      stroke="#6D6F70"
      strokeWidth="1px"
    ></rect>
    
    <text
      x="405"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      No Data
    </text>
    

  
  </svg>
      </>
    )
  
}